<template>
    <div class="main-content setting">
        <h2>公司信息</h2>
        <div class="b-b m-b-md"></div>
        <div class="clearfix">
            <form>
                <div class="clearfix">
                    <div class="col-xs-12 col-sm-8">
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">公司名称：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="公司名称：北京华宇互联科技有限公司" required="required" v-model.trim="companyInfo.name" autocomplete="off" readonly>
                                    <span class="input-tips">{{error.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">公司简称：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="公司简称：华宇互联" required="required" v-model.trim="companyInfo.short_name" autocomplete="off">
                                    <span class="input-tips">{{error.short_name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">统一社会信用代码：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="统一社会信用代码：9188888888888888888N" required="required" v-model.trim="companyInfo.credit_code" autocomplete="off">
                                    <span class="input-tips">{{error.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">注册邮箱：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="注册邮箱：test@test.com" required="required" v-model.trim="companyInfo.email" autocomplete="off">
                                    <span class="input-tips">{{error.email}}</span>
                                    <verify-code :val="companyInfo.email" :msg="error.email" :type="2" v-show="companyInfo.email != user.email && verify.email" @success="verifySuccess"></verify-code>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">绑定手机：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="绑定手机：18888888888" required="required" v-model.trim="companyInfo.phone" autocomplete="off">
                                    <span class="input-tips">{{error.phone}}</span>
                                    <verify-code :val="companyInfo.phone" :msg="error.phone" :type="1" v-show="(companyInfo.phone != company.phone && verify.phone)||user.phone_is_verify === -1" @success="verifySuccess"></verify-code>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">联系人姓名：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="联系人姓名：小明" required="required" v-model.trim="companyInfo.principal.name" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">联系人电话：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="联系人电话：18888888888" required="required" v-model.trim="companyInfo.principal.phone" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                                                    <div class="input-item">
                                                        <label class="col-sm-4 n-p-r text-right">公司介绍：</label>
                                                        <div class="col-sm-6">
                                                            <textarea class="input textarea" resize="none" placeholder="公司介绍：不超过250字" required="required" v-model.trim="companyInfo.desc" autocomplete="off"></textarea>
                                                        </div>
                                                    </div>
                                                </div> -->
                    </div>
                    <div class="col-xs-12 col-sm-4 ">
                        <img :src="companyInfo.logo" :alt="companyInfo.name" class="avatar">
                        <div class="p-t-sm text-center">
                            (推荐尺寸:200 x 200,3M以内)
                        </div>
                        <div class="p-t-sm text-center">
                            <button type="button" class="btn btn-sm btn-primary upload-btn" id="upload-logo-btn">选择Logo</button>
                        </div>
                    </div>
                </div>
                <div class="p-t-b-md text-center">
                    <button type="button" class="btn btn-primary" @click="completeInfo()">保存企业信息</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WebUploader from 'webuploader';
import Company from '../../resource/company';
import User from '../../resource/user';
export default {
    data: function() {
        return {
            companyInfo: {
                name: '',
                short_name: '',
                credit_code: '',
                email: '',
                phone: '',
                logo: '',
                principal: {},
                desc: ''
            },
            company: {},
            verify: {
                phone: false,
                email: false
            },
            error: {
                name: '',
                short_name: '',
                email: '',
                phone: '',
                credit_code: '',
                principal: {}
            }
        };
    },
    computed: {
        ...mapGetters({
            user: 'loginUser'
        })
    },
    created: function() {
        let that = this;
        if (that.user && that.user.category === 2) {
            Company.get({ _id: that.user.user_company._id }, {}).then(
                res => {
                    let data = res.body;
                    if (data.code === 0) {
                        that.company = data.result;
                        for (let prop in that.companyInfo) {
                            that.companyInfo[prop] = that.company[prop];
                        }
                    } else {
                        alert(data.msg);
                    }
                },
                res => {}
            );
        } else {
            that.$router.replace('/user');
        }
    },
    watch: {
        'companyInfo.email': function(now) {
            let that = this;
            if (that.global.regex.email.test(now)) {
                that.error.email = '';
                that.verify.email = true;
            } else {
                that.error.email = '请输入正确的邮箱地址';
                that.verify.email = false;
            }
        },
        'companyInfo.phone': function(now) {
            let that = this;
            if (that.global.regex.phone.test(now)) {
                that.error.phone = '';
                that.verify.phone = true;
            } else {
                that.error.phone = '请输入正确的手机号';
                that.verify.phone = false;
            }
        }
    },
    mounted: function() {
        let that = this;
        document.title = `公司信息设置-企业控制台|${that.global.name}`;
        let uploader = WebUploader.create({
            auto: true,
            server: '/api/upload',
            pick: {
                id: '#upload-logo-btn',
                innerHTML: '',
                multiple: false
            },
            formData: {}
        });
        uploader.on('beforeFileQueued', file => {
            if (!file.type.startsWith('image/')) {
                alert('请选择图片文件后再进行上传');
                return false;
            } else if (file.size > 3145728) {
                alert('请选择3M以内图片进行上传');
                return false;
            } else {
                return true;
            }
        });
        uploader.on('uploadSuccess', (file, res) => {
            if (res.code === 0) {
                that.companyInfo.logo = res.result.url;
            } else {
                alert(res.msg);
            }
        });
    },
    methods: {
        ...mapActions({
            setUserProperty: 'setUserProperty'
        }),
        completeInfo: function() {
            let that = this;
            User.complete({}, that.companyInfo).then(
                res => {
                    let data = res.body;
                    if (data.code == 0) {
                        that.$store.dispatch('getSession');
                        alert('修改已保存');
                    } else {
                        alert(data.msg);
                    }
                },
                res => {}
            );
        },
        verifySuccess: function(type) {
            let that = this;
            that.setUserProperty(
                type === 1 ? 'phone_is_verify' : 'email_is_verify',
                1
            );
        }
    }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// setting.vue?d87b91ca